var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.checkOut}},[_vm._v(" Check Out ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }